import { event_mockDbHotReload } from "@/mock-api/db.events.ts";
import type { QueryClient } from "@tanstack/react-query";
import { discardPromise, type SomePromise } from "@warrenio/utils/promise/discardPromise";
import { useCallback, useEffect } from "react";

/** Invalidates the query client's cache on mock DB code changes */
export function useMockQueryHotReload(queryClient: QueryClient) {
    useMockDbHotReload(
        useCallback(async () => await queryClient.invalidateQueries(), [queryClient]),
        "Invalidating all queries",
    );
}

export function useMockDbHotReload(onReload: () => SomePromise, logMessage: string) {
    if (!import.meta.env.DEV) return;

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        function handleReload() {
            console.debug("Hot reload mock DB: %s", logMessage);
            discardPromise(onReload());
        }

        document.addEventListener(event_mockDbHotReload, handleReload);
        return () => document.removeEventListener(event_mockDbHotReload, handleReload);
    }, [onReload, logMessage]);
}
